import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { fadeUp } from "../../lib/motion";

export default function ArticleCard({ article }) {
  return (
    <motion.article
      variants={fadeUp}
      className="card-lift group flex flex-col overflow-hidden rounded-2xl border border-border bg-card hover:border-electric/40 hover:shadow-card-hover"
      data-testid={`article-card-${article.slug}`}
    >
      <Link to={`/recursos/${article.slug}`} className="flex h-full flex-col p-7">
        <span className="self-start rounded-full border border-electric/30 bg-electric/10 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-electric">
          {article.category}
        </span>
        <h3 className="mt-5 font-display text-lg font-semibold leading-snug transition-colors duration-200 group-hover:text-brand">
          {article.title}
        </h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{article.excerpt}</p>
        <div className="mt-6 flex items-center justify-between border-t border-border pt-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <CalendarDays className="h-3.5 w-3.5" />
            {new Date(`${article.date}T12:00:00`).toLocaleDateString("es-DO", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            <span className="mx-1">·</span>
            {article.readTime}
          </span>
          <ArrowUpRight className="h-4 w-4 text-electric opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
        </div>
      </Link>
    </motion.article>
  );
}
